// import React, {Component} from 'react';

// class CustomSelect extends Component{
//     constructor(props){
//         super(props)
//     }

//     //On the change event for the select box pass the selected value back to the parent
//     handleChange = (event) =>
//     {
//         let selectedValue = event.target.value;
//         this.props.onSelectChange(selectedValue);
//     }

//     render(){
//         let arrayOfData = this.props.arrayOfData;
//         let options = arrayOfData.map((data) =>
//                 <option 
//                     key={data.id}
//                     value={data.id}
//                 >
//                     {data.name}
//                 </option>
//             );

//             return (
//             <select name="customSearch" className="inputclass form-control" onChange={this.handleChange}>
//                 <option>Category</option>
//                 {options}
//            </select>
//         )
//     }
// }

// export default CustomSelect;


// import React from "react";

// const CustomSelect = props => {
//   return (
//     <div className="form-group">
//       <label for={props.name}> {props.title} </label>
//       <select
//         id={props.name}
//         name={props.name}
//         value={props.value}
//         onChange={props.handleChange}
//         className="form-control"
//       >
//         <option value="" disabled>
//           {props.placeholder}
//         </option>
//         {props.options.map(option => {
//           return (
//             <option key={option} value={option} label={option}>
//               {option}
//             </option>
//           );
//         })}
//       </select>
//     </div>
//   );
// };

// export default CustomSelect;


import React from "react";

const Dropdowm = ({ options, title }) => (
  // <h1>{title}</h1>
  <div className="form-group">
    <select className="inputclass form-control select-control">
      {options.map(option => (
        <option value={option.value}>{option.label}</option>
      ))}
    </select>
  </div>
);

export default Dropdowm;
